"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _fareCalendar = require("../../clients/fare-calendar.client");
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _mobxUtils = require("mobx-utils");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _search = require("../../utils/search.utils");
var _is_before = _interopRequireDefault(require("date-fns/is_before"));
var _is_equal = _interopRequireDefault(require("date-fns/is_equal"));
var _fareCalendar2 = require("../../utils/fare-calendar.utils");
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _constants2 = require("../../constants");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var FareCalendarStore = exports.default = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, (_class = function () {
  function FareCalendarStore(initialState, $env) {
    var _this = this;
    if (initialState === void 0) {
      initialState = {};
    }
    (0, _classCallCheck2.default)(this, FareCalendarStore);
    this.$env = void 0;
    (0, _initializerDefineProperty2.default)(this, "data", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "pricingData", _descriptor2, this);
    (0, _initializerDefineProperty2.default)(this, "priceChange", _descriptor3, this);
    (0, _initializerDefineProperty2.default)(this, "API_STATE", _descriptor4, this);
    (0, _initializerDefineProperty2.default)(this, "filtersQuery", _descriptor5, this);
    (0, _initializerDefineProperty2.default)(this, "fareCalendarQuery", _descriptor6, this);
    (0, _initializerDefineProperty2.default)(this, "fareCalendarBaseQuery", _descriptor7, this);
    (0, _initializerDefineProperty2.default)(this, "queryMap", _descriptor8, this);
    (0, _initializerDefineProperty2.default)(this, "range", _descriptor9, this);
    (0, _initializerDefineProperty2.default)(this, "selectedKey", _descriptor10, this);
    this.shouldFetch = (0, _mobxUtils.computedFn)(function (query, filtersQuery) {
      return !((0, _has2.default)(_this.queryMap, query) && _this.queryMap[query] === filtersQuery);
    });
    this.fetch = (0, _mobx.flow)(function (_ref) {
      var _this2 = this;
      var query = _ref.query,
        _ref$airline = _ref.airline,
        airline = _ref$airline === void 0 ? [] : _ref$airline,
        _ref$stops = _ref.stops,
        stops = _ref$stops === void 0 ? [] : _ref$stops,
        _ref$timeSlots = _ref.timeSlots,
        timeSlots = _ref$timeSlots === void 0 ? {} : _ref$timeSlots,
        _ref$airports = _ref.airports,
        airports = _ref$airports === void 0 ? {} : _ref$airports,
        _ref$filtersQuery = _ref.filtersQuery,
        filtersQuery = _ref$filtersQuery === void 0 ? "" : _ref$filtersQuery,
        _ref$range = _ref.range,
        range = _ref$range === void 0 ? _constants2.PRICING_DATE_RANGE : _ref$range,
        _ref$errorHandler = _ref.errorHandler,
        errorHandler = _ref$errorHandler === void 0 ? function () {} : _ref$errorHandler,
        _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? {} : _ref$headers;
      return _regeneratorRuntime().mark(function _callee() {
        var requestPayload, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this2.shouldFetch(query, filtersQuery)) {
                _context.next = 3;
                break;
              }
              _this2.API_STATE = _constants.API_STATE.SUCCESS;
              return _context.abrupt("return");
            case 3:
              _this2.API_STATE = _constants.API_STATE.LOADING;
              _context.prev = 4;
              requestPayload = (0, _fareCalendar2.generateFareCalenderRequest)({
                query: query,
                airline: airline,
                stops: stops,
                timeSlots: timeSlots,
                airports: airports,
                range: range
              });
              _context.next = 8;
              return _fareCalendar.FareCalendarClient.getFareCalendarPricing(requestPayload, headers);
            case 8:
              response = _context.sent;
              _this2.onSuccess(response, {
                query: query,
                range: range,
                filtersQuery: filtersQuery
              });
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](4);
              _this2.onError(_context.t0, errorHandler);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4, 12]]);
      })();
    });
    this.$env = $env;
    this.updateInitialState(initialState);
  }
  (0, _createClass2.default)(FareCalendarStore, [{
    key: "isLoading",
    get: function get() {
      return this.API_STATE === _constants.API_STATE.LOADING;
    }
  }, {
    key: "isFetched",
    get: function get() {
      return this.API_STATE === _constants.API_STATE.SUCCESS;
    }
  }, {
    key: "hasError",
    get: function get() {
      return this.API_STATE === _constants.API_STATE.FAILED;
    }
  }, {
    key: "pricingMap",
    get: function get() {
      return (0, _fareCalendar2.getPricingMap)({
        pricingData: this.pricingData,
        $currency: this.$env.currency
      });
    }
  }, {
    key: "priceUp",
    get: function get() {
      return this.priceChange > 0;
    }
  }, {
    key: "priceDown",
    get: function get() {
      return this.priceChange < 0;
    }
  }, {
    key: "pricingCompleteness",
    get: function get() {
      return (0, _fareCalendar2.getPricingCompleteness)(this.pricingMap);
    }
  }, {
    key: "baseDepartureDate",
    get: function get() {
      return (0, _search.getDepartureDateFromQuery)(this.fareCalendarBaseQuery);
    }
  }, {
    key: "baseReturnDate",
    get: function get() {
      return (0, _search.getReturnDateFromQuery)(this.fareCalendarBaseQuery);
    }
  }, {
    key: "displayedReturnDate",
    get: function get() {
      return (0, _search.getReturnDateFromQuery)(this.fareCalendarQuery) || "";
    }
  }, {
    key: "displayedDepartureDate",
    get: function get() {
      return (0, _search.getDepartureDateFromQuery)(this.fareCalendarQuery);
    }
  }, {
    key: "basePricingKey",
    get: function get() {
      return (0, _fareCalendar2.constructPricingKey)(this.baseDepartureDate, this.baseReturnDate);
    }
  }, {
    key: "departureDateRange",
    get: function get() {
      return (0, _fareCalendar2.generateFareCalendarDateRange)(this.displayedDepartureDate, this.range);
    }
  }, {
    key: "returnDateRange",
    get: function get() {
      return this.displayedReturnDate && (0, _fareCalendar2.generateFareCalendarDateRange)(this.displayedReturnDate, this.range);
    }
  }, {
    key: "sameDepartureReturn",
    get: function get() {
      return (0, _is_equal.default)(this.displayedDepartureDate, this.displayedReturnDate);
    }
  }, {
    key: "hasMaxDeparture",
    get: function get() {
      return this.sameDepartureReturn || (0, _fareCalendar2.shouldDisableDeparture)(this.displayedDepartureDate, this.displayedReturnDate);
    }
  }, {
    key: "hasMinDeparture",
    get: function get() {
      return (0, _is_before.default)(this.departureDateRange[0], new Date());
    }
  }, {
    key: "hasMinReturn",
    get: function get() {
      return this.sameDepartureReturn || (0, _is_before.default)(this.displayedReturnDate, this.displayedDepartureDate) || (0, _is_before.default)(this.returnDateRange[0], new Date());
    }
  }, {
    key: "pricingFilters",
    get: function get() {
      return (0, _fareCalendar2.getPricingFilters)(this.filtersQuery, {});
    }
  }, {
    key: "updatePricing",
    value: function updatePricing(pricingKey, pricingValue) {
      var pricingItem = this.pricingData[pricingKey];
      if ((0, _isPlainObject2.default)(pricingItem)) {
        var currentPrice = pricingItem.price;
        var nextPrice = pricingValue || null;
        var _getPriceChangeDetail = (0, _fareCalendar2.getPriceChangeDetails)(currentPrice, nextPrice),
          price = _getPriceChangeDetail.price,
          priceChange = _getPriceChangeDetail.priceChange;
        this.priceChange = priceChange;
        this.pricingData[pricingKey].price = price;
      }
    }
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "updateFareCalendarBaseQuery",
    value: function updateFareCalendarBaseQuery(query) {
      this.fareCalendarBaseQuery = query;
    }
  }, {
    key: "updateFareCalendarQuery",
    value: function updateFareCalendarQuery(query) {
      this.fareCalendarQuery = query;
    }
  }, {
    key: "setPricingRange",
    value: function setPricingRange(range) {
      this.range = range;
    }
  }, {
    key: "setFiltersQuery",
    value: function setFiltersQuery(query) {
      this.filtersQuery = query;
    }
  }, {
    key: "setSelectedKey",
    value: function setSelectedKey(key) {
      this.selectedKey = key;
    }
  }, {
    key: "onSuccess",
    value: function onSuccess(data, _temp) {
      var _ref2 = _temp === void 0 ? {
          range: _constants2.PRICING_DATE_RANGE,
          query: "",
          filtersQuery: ""
        } : _temp,
        range = _ref2.range,
        query = _ref2.query,
        filtersQuery = _ref2.filtersQuery;
      this.API_STATE = _constants.API_STATE.SUCCESS;
      if ((0, _isPlainObject2.default)(data)) {
        this.data = _objectSpread(_objectSpread({}, this.data), data);
      }
      this.queryMap[query] = filtersQuery;
      this.range = range;
      var pricingData = (0, _fareCalendar2.initializePricingData)({
        payload: data,
        range: range,
        query: query,
        convertPrice: this.$env.currency.convertPrice
      });
      if ((0, _isPlainObject2.default)(pricingData)) {
        this.pricingData = _objectSpread(_objectSpread({}, this.pricingData), pricingData);
      }
    }
  }, {
    key: "onError",
    value: function onError(error, errorHandler) {
      this.API_STATE = _constants.API_STATE.FAILED;
      errorHandler(error);
    }
  }]);
  return FareCalendarStore;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "pricingData", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "priceChange", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "API_STATE", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _constants.API_STATE.INITIAL;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filtersQuery", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "fareCalendarQuery", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "fareCalendarBaseQuery", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor8 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "queryMap", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor9 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "range", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _constants2.PRICING_DATE_RANGE;
  }
}), _descriptor10 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "selectedKey", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isLoading", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoading"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFetched", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFetched"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasError", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasError"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "pricingMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pricingMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "priceUp", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "priceUp"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "priceDown", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "priceDown"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "pricingCompleteness", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pricingCompleteness"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "baseDepartureDate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "baseDepartureDate"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "baseReturnDate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "baseReturnDate"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedReturnDate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedReturnDate"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedDepartureDate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedDepartureDate"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "basePricingKey", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "basePricingKey"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "departureDateRange", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "departureDateRange"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "returnDateRange", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "returnDateRange"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "sameDepartureReturn", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sameDepartureReturn"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasMaxDeparture", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMaxDeparture"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasMinDeparture", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMinDeparture"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasMinReturn", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMinReturn"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "pricingFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pricingFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updatePricing", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "updatePricing"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateFareCalendarBaseQuery", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "updateFareCalendarBaseQuery"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateFareCalendarQuery", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "updateFareCalendarQuery"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setPricingRange", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "setPricingRange"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setFiltersQuery", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "setFiltersQuery"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setSelectedKey", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedKey"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onSuccess", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onError", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype)), _class));